import React, {useState,useContext } from 'react';
import { Modal } from 'react-bootstrap';
import { LabelText } from '../../Language';
import CustomOverlayTrigger from '../../../hoc/CustomOverlayTrigger';
import { changeRequestTooltip } from '../Tooltip/Tooltip';
import './ElearningPopup.css';
import { Link } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import {elearningSubmit} from '../../../../src/services/business-partner-api';
import { LanguageContext } from '../../../containers/Language/LanguageProvider';


const ElearningPopup = (props) => {
    const [show, setShow] = useState(true);
    const {language} = useContext(LanguageContext);
    const [checked, setChecked] = React.useState(false);

    const handleChange = () => {
     setChecked(!checked);
    };

    const handleClose= () => {
        setShow(false);
        if(checked === true){
            async function elearningSubmitApi(){
                await elearningSubmit(props.BusinessPartnerCode,props.UserId)
            }
            elearningSubmitApi();
        }
        props.setShowElearningPopup();
    };

    const handleXclose = () =>{
        setShow(false)
        props.setShowElearningPopup();
    }

      return (
        <div className="UnblockSuccess-Modal-container">
            <Modal dialogClassName={language.id === "1" ? "Elearning-popupEN" : "Elearning-popup"} show={show} 
                onHide={handleXclose}
                backdrop="static"
                keyboard={true}
                scrollable={true}>
                {
                    <Modal.Header closeButton={true}
                        className="Elearning-Modal-header scroller"
                        style={{ backgroundColor: '#25336C' }} >
                        <div>
                        <LabelText tid="Welcome" />
                        </div>
                    </Modal.Header>
                }
                <Modal.Body className="scroller">
                    <div className="Bulk-processing-body">
                        <div >
                            <div className="elearningpopup-BusinessPartner-label">
                            <LabelText tid="elearning_popup_line1" /><br></br>
                            <LabelText tid="elearning_popup_line2" /><br></br>
                            <LabelText tid="elearning_popup_line3" /><br></br>
                            </div>
                        </div><br></br>
                        <Form>
                           <div key={'default-checkbox'} className="elearningpopup-checkbox-label">
                            <Form.Check 
                             type= 'checkbox'
                             id={'default-checkbox'}
                             label={<LabelText tid="elearning_popup_checkbox" />}
                             checked={checked}
                             onChange={handleChange}
                             />
                            <Form/>
                           </div>
                        </Form>     
                        
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="UnblockSuccess-Button-Container">
                        <div>
                        <div className="elearningpopup-Request-Btn-Container">
                                <Link to="/elearning">
                                <div className="elearning-popup-button" role={"button"} tabIndex={0}
                                        onClick={handleClose}
                                    ><LabelText tid="elearning" /></div>
                                    </Link>
                            </div>
                            <div className="elearningpopup-Request-Btn-Container">
                                <CustomOverlayTrigger placement="left" tooltip={changeRequestTooltip("close")}>
                                    <div className="elearning-popup-close-button" role={"button"} tabIndex={0}
                                        onClick={handleClose}
                                    ><LabelText tid="close" /></div>
                                </CustomOverlayTrigger>
                            </div>
                           
                            </div>                    
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    )
};

export default ElearningPopup;